import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randAggregation } from "@ngneat/falso";

export const randAggregationNodeDef = createNodeDef({
  type: "randAggregation",
  displayName: "Aggregation",
  defaultName: "aggregration",
  fields: [
    { type: DataFieldType.NUMBER, key: "values", label: "Values" },
    { type: DataFieldType.NUMBER, key: "totalValue", label: "Total" },
    { type: DataFieldType.BOOLEAN, key: "noZeros", label: "No zeros" },
  ],
  initialData: () => ({
    values: 2,
    totalValue: 100,
    noZeros: false,
  }),
  generate: ({ node }) => {
    return randAggregation({
      values: node.data.values as 2,
      totalValue: node.data.totalValue,
      noZeros: node.data.noZeros,
    });
  },
});
